import { initialState, SET_AREA, CLEAR_AREA } from 'store';

export default (state = initialState.area, { type, payload }) => {
  switch (type) {
    case SET_AREA:
      localStorage.setItem('area_id', payload.id);
      return payload;
    case CLEAR_AREA:
      localStorage.removeItem('area_id');
      return initialState.area;
    default:
      return state;
  }
};
